module.exports = __webpack_public_path__ + "static/media/couple.e42b24a6.svg";